import useOutsideClick from "hook/useOutsideClick";
import { setWardsCurrentPageNo } from "pages/AllWards/allWardsSlice";
import { setCurrentPageNo } from "pages/UserManagement/userSlice";
import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import {
  AccountOutline,
  CouncillorsOutline,
  InitiativesArticlesIcon,
  NewsOutline,
  NotificationOutline,
  ReportIcon,
  WardsOutline,
} from "themes/Icon";
import CollapseComp from "themes/elements/Collapse";
import { isPermit } from "utils/permissionCheck";
import style from "./sidenav.module.scss";
import "./sidenav.scss";
function SideNav({ sideMenu, setSideMenu }) {
  const dispatch = useDispatch();
  const location = useLocation();
  const [active, setActive] = useState(0);
  const navRef = useRef(null);

  const collapseData = [];
  const collapseWards = [];
  const collapseArticleData = [];

  const permissionsNeeded = ["view", "delete", "create", "edit"];

  const hasNotificationAccess = permissionsNeeded.some((permission) =>
    isPermit(4, permission)
  );
  const hasNewsManagementAccess = permissionsNeeded.some((permission) =>
    isPermit(3, permission)
  );
  const hasUserAccess = permissionsNeeded.some((permission) =>
    isPermit(2, permission)
  );

  const hasCounsilorAccess = permissionsNeeded.some((permission) =>
    isPermit(7, permission)
  );
  const hasWardsAccess = permissionsNeeded.some((permission) =>
    isPermit(5, permission)
  );

  const hasProjectAccess = permissionsNeeded.some((permission) =>
    isPermit(8, permission)
  );

  const hasRoleAccess = permissionsNeeded.some((permission) =>
    isPermit(1, permission)
  );
  // Add 'News Management' if the user has 'create', 'view', or 'delete' permission
  if (hasNewsManagementAccess) {
    collapseData.push({
      title: "My News Article",
      link: "/news-management",
    });
  }

  if (hasProjectAccess) {
    collapseArticleData.push({
      title: "All articles",
      link: "/all-articles",
    });
  }

  if (isPermit(8, "approve_reject")) {
    collapseArticleData.push({
      title: "Approval Management",
      link: "/articles-approval-management",
    });
  }

  // Add 'Approval Management' if the user has 'approve_reject' permission
  if (isPermit(3, "approve_reject")) {
    collapseData.push({
      title: "Approval Management",
      link: "/approval-management",
    });
  }

  if (hasWardsAccess) {
    collapseWards.push({ title: "All Wards", link: "/all-wards" });
  }
  if (isPermit(5, "approve_reject")) {
    collapseWards.push({
      title: "Approval Management",
      link: "/wards-approval-management",
    });
  }
  const CollapseItems =
    hasNewsManagementAccess || isPermit(3, "approve_reject")
      ? [
          {
            key: "1",
            icon: <NewsOutline />,
            label: "News management",
            children: (
              <ul className="menu-wrapper">
                {collapseData.map((item, i) => {
                  const location = useLocation(); // Ensuring location is defined in the correct scope
                  return (
                    <Link
                      key={i}
                      to={item.link}
                      className={`menu-item ${
                        location.pathname === item.link ? "active" : ""
                      }`}
                    >
                      {item.title}
                    </Link>
                  );
                })}
              </ul>
            ),
          },
        ]
      : [];

  const NotificationCollapseItems =
    hasNotificationAccess || isPermit(3, "approve_reject")
      ? [
          {
            key: "notification-collapse",
            icon: <NotificationOutline />,
            label: (
              <Link
                to="/notification"
                style={{ color: "inherit", textDecoration: "none" }}
                onClick={() =>
                  window.dispatchEvent(new CustomEvent("app:notification-home"))
                }
              >
                Notification
              </Link>
            ),
            children: (
              <ul className="menu-wrapper">
                {hasNotificationAccess && (
                  <Link
                    to="/notification"
                    className={`menu-item ${
                      location.pathname === "/notification" ? "active" : ""
                    }`}
                    onClick={() =>
                      window.dispatchEvent(
                        new CustomEvent("app:notification-home")
                      )
                    }
                  >
                    My Notifications
                  </Link>
                )}
                {isPermit(3, "approve_reject") && (
                  <Link
                    to="/notification-approval-management"
                    className={`menu-item ${
                      location.pathname === "/notification-approval-management" ? "active" : ""
                    }`}
                    onClick={() =>
                      window.dispatchEvent(
                        new CustomEvent("app:notification-approval-home")
                      )
                    }
                  >
                    Approval Management
                  </Link>
                )}
              </ul>
            ),
          },
        ]
      : [];

  const CollapseItemsWards =
    hasWardsAccess || isPermit(5, "approve_reject")
      ? [
          {
            key: "2",
            icon: <WardsOutline />,
            label: "Wards",
            children: (
              <ul className="menu-wrapper">
                {collapseWards.map((item, i) => {
                  const location = useLocation(); // Ensuring location is defined in the correct scope
                  return (
                    <Link
                      onClick={() => dispatch(setWardsCurrentPageNo(1))}
                      key={i}
                      to={item.link}
                      className={`menu-item ${
                        location.pathname === item.link ? "active" : ""
                      }`}
                    >
                      {item.title}
                    </Link>
                  );
                })}
              </ul>
            ),
          },
        ]
      : [];

  const CollapseItemsArticles =
    hasProjectAccess || isPermit(8, "approve_reject")
      ? [
          {
            key: "3",
            icon: <InitiativesArticlesIcon />,
            label: "Initiatives & Projects",
            children: (
              <ul className="menu-wrapper">
                {collapseArticleData.map((item, i) => {
                  const location = useLocation(); // Ensuring location is defined in the correct scope
                  return (
                    <Link
                      key={i}
                      to={item.link}
                      className={`menu-item ${
                        location.pathname === item.link ? "active" : ""
                      }`}
                    >
                      {item.title}
                    </Link>
                  );
                })}
              </ul>
            ),
          },
        ]
      : [];

  const navLink = [
    {
      icon: <AccountOutline />,
      title: "User management",
      link: "/user-management",
    },
  ];

  useEffect(() => {
    // Set active tab based on the current path
    if (
      location.pathname === "/my-news-article" ||
      location.pathname === "/approval-management" ||
      location.pathname === "/news-management"
    ) {
      setActive(1); // Assuming '1' is the index for news-related items
    } else if (
      location.pathname === "/all-wards" ||
      location.pathname === "/wards-approval-management"
    ) {
      setActive(2); // Assuming '2' is the index for ward-related items
    } else if (
      location.pathname === "/all-articles" ||
      location.pathname === "/articles-approval-management"
    ) {
      setActive(3); // Assuming '3' is the index for project-related items
    } else {
      setActive(0); // Default or home tab
    }
    setSideMenu(false); // Assuming you want to close the side menu on route change
  }, [location.pathname]);
  useOutsideClick(navRef, () => setSideMenu(false));

  const navClass = sideMenu ? style["active"] : "";

  return (
    <nav ref={navRef} className={`${style["side-navbar"]} ${navClass}`}>
      {navLink.map((item, i) => {
        return (
          <Link
            key={i}
            onClick={() => dispatch(setCurrentPageNo(1))}
            to={item.link}
            className={`${style["menu-container"]} ${
              location.pathname == item.link ||
              ((location.pathname === "/" ||
                location.pathname === "/user-management/manage-roles") &&
                i === 0)
                ? style["active"]
                : ""
            }`}
          >
            <span className={style["menu-icon"]}>{item.icon}</span>
            <h6 className={style["menu-item"]}>{item.title}</h6>
          </Link>
        );
      })}

      {CollapseItems.length > 0 && (
        <CollapseComp
          active={active}
          setActive={setActive}
          className={`side-menu-collapse ${
            location.pathname === "/my-news-article" ||
            location.pathname === "/approval-management" ||
            location.pathname === "/news-management"
              ? "active"
              : null
          }`}
          data={CollapseItems}
        />
      )}
      {NotificationCollapseItems.length > 0 && (
        <CollapseComp
          active={active}
          setActive={setActive}
          className={`side-menu-collapse ${
            location.pathname === "/notification" ||
            location.pathname === "/notification-approval-management"
              ? "active"
              : null
          }`}
          data={NotificationCollapseItems}
        />
      )}
      {CollapseItemsWards.length > 0 && (
        <CollapseComp
          active={active}
          setActive={setActive}
          className={`side-menu-collapse ${
            location.pathname === "/all-wards" ||
            location.pathname === "/wards-approval-management"
              ? "active"
              : null
          }`}
          data={CollapseItemsWards}
        />
      )}
      {isPermit(6, "view") && (
        <Link
          to="/incident-report"
          className={`${style["menu-container"]} ${
            location.pathname == "/incident-report" ? style["active"] : ""
          }`}
        >
          <span className={style["menu-icon"]}>
            <ReportIcon />
          </span>
          <h6 className={style["menu-item"]}>Incident Report </h6>
        </Link>
      )}
      {hasCounsilorAccess && (
        <Link
          to="/councillors"
          className={`${style["menu-container"]} ${
            location.pathname == "/councillors" ? style["active"] : ""
          }`}
        >
          <span className={style["menu-icon"]}>
            <CouncillorsOutline />
          </span>
          <h6 className={style["menu-item"]}>Councillors</h6>
        </Link>
      )}
      {CollapseItemsArticles.length > 0 && (
        <CollapseComp
          active={active}
          setActive={setActive}
          className={`side-menu-collapse ${
            location.pathname === "/all-articles" ||
            location.pathname === "/articles-approval-management"
              ? "active"
              : null
          }`}
          data={CollapseItemsArticles}
        />
      )}
      {/* <Link to="#" className={`${style["menu-container"]} `}>
        <span className={style["menu-icon"]}>
          <SettingsOutline />
        </span>
        <h6 className={style["menu-item"]}>Settings</h6>
      </Link> */}
    </nav>
  );
}

export default SideNav;
